import { usePeriodsQuery } from '@/app/services/periodApi';
import { usePeriod } from '@/context/PeriodContext';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

export default function PeriodInitializer() {
  const { selectedPeriod, setSelectedPeriod } = usePeriod();
  const [size, setSize] = useState(5);

  const { data, isSuccess } = usePeriodsQuery(size);

  useEffect(() => {
    if (isSuccess && data?.content) {
      setSelectedPeriod(data.content[0]);
    }
  }, [data, isSuccess, setSelectedPeriod]);

  return <Outlet />;
}
